import qs from "qs";

export function replaceQuery(url, obj: Object | null) {
    if (obj === null) {
        return url.replace(/(\?.*)$/, '')
    }
    const query = parseQuery(url)
    obj = Object.assign({}, query, obj)
    if (url.indexOf('?') !== -1) {
        return url.replace(/\?.*$/, '?' + qs.stringify(obj))
    }
    return url + '?' + qs.stringify(obj)
}

export function parseQuery(url) {
    return qs.parse((new URL(url)).search?.replace(/^\??/, ''))
}
